import { useContext } from 'react'
import swal from 'sweetalert2'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import PageContext from '@contexts/pageContext'

import useBrandGroupPublication from '@hooks/useBrandGroupPublication'
import { generateUrls } from '@hooks/usePublication'

import type { HandleCallbackActionParams } from '@domain-group/javascript-utils'

import type { BrandGroupPublicationModel } from '@models/types'

const confirmDelete = (
  deleteBrandGroupPublication: (payload: HandleCallbackActionParams) => Promise<object>,
  deleteFn: () => void,
) => {
  const deleteBrandGroupPublicationPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Publication Removed',
  }

  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Remove Publication?',
    })
    .then(({ value }) => {
      if (value){
        // @ts-expect-error TS2345
        deleteBrandGroupPublication(deleteBrandGroupPublicationPayload)
      }
    })
}

const BrandGroupPublicationListItem = (props: { brandGroupPublication: BrandGroupPublicationModel }) => {
  const { brandGroupPublication } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: { deleteBrandGroupPublication },
  } = pageContext

  const {
    callbacks: {
      deleteBrandGroupPublication: deleteFn,
    },
    publication,
  } = useBrandGroupPublication(brandGroupPublication)

  const { title: publicationTitle } = publication

  const { editPublicationUrl } = generateUrls({ id: publication.id })

  return (
    <DashboardModuleListItem title={publicationTitle}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => confirmDelete(deleteBrandGroupPublication, deleteFn)}
          type="delete"
        />

        <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            href={`${editPublicationUrl}?redirect=${generateRedirectUrl()}`}
            type="link"
          />
        </ScopedConditionalContent>
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default BrandGroupPublicationListItem
